export default __webpack_public_path__ + "static/media/3.53cf4647.jpg";